/**
 * Sentry test component for debugging
 */

import React from "react";
import {
  captureException,
  captureMessage,
  addBreadcrumb,
} from "../../config/sentry";

export const SentryTest: React.FC = () => {
  const triggerError = () => {
    try {
      // This will throw an error
      const obj: unknown = null;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (obj as any).someProperty.that.does.not.exist();
    } catch (error) {
      captureException(error as Error, {
        component: "SentryTest",
        action: "triggerError",
      });
    }
  };

  const triggerMessage = () => {
    captureMessage("Test message from SentryTest component", "info", {
      component: "SentryTest",
      action: "triggerMessage",
    });
  };

  const addTestBreadcrumb = () => {
    addBreadcrumb("Test breadcrumb added", "user-action", "info", {
      component: "SentryTest",
      timestamp: new Date().toISOString(),
    });
  };

  return (
    <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
      <h3 className="text-lg font-medium text-yellow-800 mb-4">
        Sentry Test Panel
      </h3>
      <div className="space-y-2">
        <button
          onClick={triggerError}
          className="block w-full px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
        >
          Trigger Error
        </button>
        <button
          onClick={triggerMessage}
          className="block w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Send Test Message
        </button>
        <button
          onClick={addTestBreadcrumb}
          className="block w-full px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          Add Breadcrumb
        </button>
      </div>
      <p className="mt-2 text-xs text-yellow-700">
        These buttons are for testing Sentry integration. Only use in
        development.
      </p>
    </div>
  );
};
